import { FONT_FAMILY } from 'styles/typography'

const themeStyles = colors => {
  const styles = {
    borderNone: {
      border: 'none',
      position: 'relative',
      background: colors.white
    },
    appointmentCard: () => {
      return {
        width: '100%',
        minHeight: 100,
        borderRadius: 5,
        border: 'none',
        fontFamily: FONT_FAMILY,
        background: colors.white
      }
    },
    calendarCard: {
      fontFamily: FONT_FAMILY,
      textAlign: 'center',
      background: colors.snowflake,
      userSelect: 'none',
      color: colors.approxBlack,
      fontWeight: 700,
      borderRadius: 5,
      width: 90,
      height: 90,
      padding: 5
    },
    mobileCalendarCard: {
      fontFamily: FONT_FAMILY,
      textAlign: 'center',
      background: colors.snowflake,
      userSelect: 'none',
      color: colors.approxBlack,
      fontWeight: 700,
      borderRadius: 5,
      margin: '0 -5px',
      padding: '5px 0px'
    },
    year: {
      weight: 400,
      size: 12
    },
    month: {
      fontSize: 12
    },
    day: {
      fontSize: 32,
      lineHeight: '32px',
      fontWeight: 700
    },
    monthMobile: {
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 700
    },
    dayMobile: {
      textAlign: 'center',
      fontSize: 28,
      fontWeight: 700
    },
    yearMobile: {
      weight: 400,
      size: 12,
      textAlign: 'center'
    },
    listTitle: {
      fontWeight: 700,
      fontSize: 16,
      marginBottom: 5,
      marginTop: 5
    },
    listHeader: {
      color: colors.approxBlack
    },
    listSubTitle: {
      fontWeight: 400,
      fontSize: 12
    },
    listThirdTitle: {
      fontWeight: 400,
      fontSize: 14
    },
    listAddToCalendarTitle: {
      fontWeight: 400,
      fontSize: 14,
      cursor: 'pointer'
    },
    button: {
      display: 'flex'
    },
    expandButton: {
      background: colors.white,
      color: colors.primary,
      fontSize: 24
    },
    expandButtonMobile: {
      background: colors.white,
      color: colors.primary,
      height: '100%',
      maxHeight: 135,
      fontSize: 20,
      position: 'absolute',
      zIndex: 100,
      top: 0,
      right: 0
    },
    startedCheckin: {
      borderRadius: 4,
      padding: '2px 8px',
      fontSize: 12,
      fontWeight: 700,
      textAlign: 'center',
      color: '#111',
      backgroundColor: colors.continueYellow
    },
    completedCheckin: {
      borderRadius: 4,
      padding: '4px 8px',
      fontSize: 12,
      fontWeight: 700,
      textAlign: 'center',
      color: '#111',
      backgroundColor: colors.completedGreen
    },
    checkin: {
      borderRadius: 4,
      padding: '4px 8px',
      fontSize: 12,
      fontWeight: 700,
      textAlign: 'center',
      color: '#111',
      backgroundColor: colors.continueYellow
    },
    placeholder: {
      height: 55
    },
    buttonGroup: {
      display: 'flex',
      overflow: 'hidden',
      position: 'absolute',
      width: '100%',
      height: 55,
      bottom: 0,
      left: 0,
      borderTop: '1px solid ' + colors.silverGray
    },
    phoneIcon: {
      height: 14,
      width: 14,
      marginRight: 5,
      fill: colors.primary
    },
    phoneIconDisabled: {
      height: 14,
      width: 14,
      marginRight: 5,
      fill: colors.secondary
    },
    calendarIcon: {
      height: 14,
      width: 14,
      marginRight: 5,
      color: colors.primary
    },
    footerButtons: {
      display: 'flex',
      background: 'none',
      border: 'none',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      color: colors.primary,
      fill: colors.primary,
      lineHeight: '16px',
      userSelect: 'none'
    },
    fisFooterButtons: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      color: colors.primary,
      lineHeight: '16px',
      userSelect: 'none'
    },
    listTitleMobile: {
      fontSize: 14,
      fontWeight: 700
    },
    listSubTitleMobile: {
      fontWeight: 400,
      fontSize: 12
    },
    listThirdTitleMobile: {
      fontSize: 13,
      fontWeight: 700
    },
    customDivider: {
      borderTop: '1px solid ' + colors.silverGray
    },
    divider: {
      borderLeft: '1px solid ' + colors.silverGray
    },
    buttons: {
      fontFamily: FONT_FAMILY,
      cursor: 'pointer',
      color: colors.primary,
      fontWeight: 700,
      border: 'none',
      background: 'none',
      display: 'flex',
      alignItems: 'center'
    },
    checkinButton: {
      display: 'flex',
      border: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      width: '330px',
      height: '35px',
      borderRadius: 35,
      background: colors.primary,
      color: colors.white,
      fontSize: 14
    },
    checkinText: {
      position: 'absolute',
      fontSize: 14,
      fontWeight: 700,
      color: colors.primary,
      right: '4rem',
      top: '1.25rem',
      zIndex: 1
    },
    checkinTextMobile: {
      marginLeft: 10,
      display: 'inline',
      textAlign: 'left'
    },
    joinInButton: {
      border: 'none',
      borderRadius: 4,
      padding: '4px 8px',
      fontSize: 12,
      fontWeight: 700,
      fontFamily: FONT_FAMILY,
      textAlign: 'center',
      color: colors.white,
      backgroundColor: colors.primary,
      cursor: 'pointer',
      elevation: 5
    },
    joinInText: {
      position: 'absolute',
      fontSize: 12,
      fontFamily: FONT_FAMILY,
      fontWeight: 700,
      color: colors.primary,
      right: '4rem',
      top: '3.5rem',
      zIndex: 1
    },
    getDirections: flag => {
      return {
        border: 'none',
        background: 'none',
        cursor: flag ? 'not-allowed' : 'pointer',
        color: !flag ? colors.primary : colors.lighterGray
      }
    },
    teleHealth: {
      marginTop: 5,
      backgroundColor: colors.teleHealth,
      height: 60,
      borderRadius: 5,
      paddingLeft: 18,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    teleHealthText: {
      color: colors.inverseColor,
      marginLeft: 6,
      marginTop: 5
    },
    teleHealthIcon: {
      fill: colors.inverseColor
    },
    successIcon: {
      color: colors.primary,
      width: '4em',
      height: '4em'
    }
  }
  styles.buttonsDisabled = {
    ...styles.buttons,
    color: colors.secondaryGray,
    pointerEvents: 'none'
  }
  styles.checkinButtonMobile = { ...styles.checkinButton, width: '100%' }
  styles.buttonCheckin = {
    ...styles.buttons,
    fontSize: 13,
    lineHeight: '20px',
    color: colors.white,
    textTransform: 'uppercase'
  }
  styles.buttonSend = { ...styles.buttons, whiteSpace: 'nowrap' }
  styles.buttonCalendar = {
    ...styles.buttons,
    whiteSpace: 'nowrap',
    width: '100%',
    justifyContent: 'center'
  }
  return styles
}

export default themeStyles
